import Title from "components/title/Title";
import React from "react";
import styles from "./GalleriesSection.module.scss";
import GalleryCard from "components/cards/galleryCard/GalleryCard";

const GalleriesSection = () => {
  return (
    <div className={styles.galleriesSectionContainer}>
      <div className="container">
        <Title text={"Galleries"} bottomStrokeWidth={"55%"} />
        <div className={styles.galleriesList}>
          <GalleryCard />
          <GalleryCard />
          <GalleryCard />
          <GalleryCard />
        </div>
        <div className={styles.viewAllCentered}>View All</div>
      </div>
    </div>
  );
};

export default GalleriesSection;
